// extracted by mini-css-extract-plugin
module.exports = {"lightSelect":"Header_lightSelect__WRMvm","phoneIcoLight":"Header_phoneIcoLight__tBuam"};